import { useEffect, useImperativeHandle, useState } from 'react';
import Switch from '../../../../components/layout/switch';
import { PilotAssignmentCommands } from '../../services/DispatcherActions';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const WastedTripCard = ({
    ref,
    onWastedTripChanged,
    assignmentService
}) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize();
        }
    }));

    const [isWastedTrip, setIsWastedTrip] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const hasEditableChanged = useHasEditableChanged();

    useEffect(() => {
        initialize()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(!hasEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasEditableChanged]);

    return (
        <Switch
            disabled={!isEditable}
            onLabel="Bomtur"
            onChange={onChangeAsync}
            checked={isWastedTrip}
            isDirty={isDirty}
        />
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;
        setIsWastedTrip(pilotAssignment.isWastedTrip);
        setIsEditable(assignmentService.isEditable);
        initializeIsDirty(pilotAssignment);
    }

    async function onChangeAsync(e) {
        setIsWastedTrip(e.value);

        await assignmentService.onIsWastedTripAsync(e.value);

        onWastedTripChanged(e.value);

        initializeIsDirty();
    }

    function initializeIsDirty() {
        setIsDirty(assignmentService.hasCommandType(PilotAssignmentCommands.IsWastedTrip));
    }
}
